















































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Form } from '@ss/mtd-vue';
import { FieldToCompontent, SysFieldToComponent } from '@/config/custom.conf.ts';
import { importComponents, firstUpperCase } from '@/utils/tool';
import { applyDrag } from '@/utils/helpers';
import eventBus from '@/utils/event-bus';

import * as systemValidator from './Template/System/systemValidator';
import { ThirdFieldUtils } from '@/utils/business';

// 批量注册组件
const systemComponent = require.context('./Template/System', false, /\.vue$/);
const basicComponent = require.context('./Template/Basic', false, /\.vue$/);

const components: any = {};

importComponents(systemComponent, components);
importComponents(basicComponent, components);

/**
 * 自定义表单
 *
 * @author liyuyao
 * @date 03/12/2020
 */

@Component({
    components
})
export default class FormIndex extends Vue {
    @Prop({
        default: () => {
            return [];
        }
    })
    fieldSchema: CommonTypes.customField[];

    @Prop({ default: false })
    editable: boolean; // 能否编辑字段设置

    @Prop({ default: false })
    readonly: boolean; // 能否填写表单内容

    @Prop({ default: false })
    dragable: boolean; // 能否拖拽

    @Prop({
        default: () => {
            return {};
        }
    })
    data: CommonTypes.mapObject;

    @Prop({ default: '' })
    name: string;

    schema: CommonTypes.customField[] = [];
    formData: any = {};

    activeKey: string = '';

    dragField: CommonTypes.customField = null;

    mounted() {
        if (this.name === 'visibleFields') {
            eventBus.$on('clickAddField', this.clickAddField);
        }
    }

    beforeDestroy() {
        // 使用具名函数移除事件，避免移除所有事件监听器
        if (this.name === 'visibleFields') {
            eventBus.$off('clickAddField', this.clickAddField);
        }
    }

    getChildPayload(index) {
        return this.formatFieldSchema[index];
    }

    // 修复添加字段失效问题
    clickAddField(field) {
        let formatField = { ...field };

        if (field.type === 1) {
            // 系统字段特殊处理
            formatField = Object.assign({}, field, {
                isHidden: field.defaultAttributes.isRequired,
                isRequired: field.defaultAttributes.isHidden
            });
        } else if (field.type === 3) {
            // 三方字段特殊处理，确保数据结构完整
            formatField = {
                ...field,
                extraSettings: { ...field.extraSettings } // 深拷贝extraSettings
            };
        }

        // 添加到schema
        this.schema.push(formatField);
        this.schemaChange();

        // 修复：确保当前状态清空，避免状态残留
        this.activeKey = '';
    }

    @Watch('fieldSchema', { immediate: true })
    getFieldSchema() {
        const changed = JSON.stringify(this.fieldSchema) !== JSON.stringify(this.schema);
        if (!changed) return;
        this.schema = this.fieldSchema;
        this.schemaChange();
    }

    @Watch('formatFieldSchema', { immediate: true })
    mountformData(schema, oldSchema) {
        // 重置formData 防止被删除的字段再出现
        this.formData = {};
        this.$refs.form && (this.$refs.form as Form).clearValidate();
        schema.forEach(field => {
            const prop = field.prop;
            // 使用传入的值或者默认值
            this.$set(this.formData, prop, this.data[prop] || field.defaultValue);
        });
        // console.log('this.formData', this.formData);
        if (this.name === 'visibleFields') {
            // 首次进入选中第一个选项
            if ((!oldSchema || !oldSchema.length) && schema.length > 0) {
                this.editFormItem(schema[0], 0);
            }
        }
    }

    @Watch('data', { immediate: true })
    mountData() {
        // 重置formData 防止被删除的字段再出现
        this.formData = {};
        for (const key in this.data) {
            this.$set(this.formData, key, this.data[key]);
        }
    }
    rule(field) {
        // 只读状态不需要校验
        if (this.readonly) {
            return;
        }
        const validateFunc = systemValidator[`validate${firstUpperCase(field.identify || '')}`];
        return { trigger: 'blur', required: field.required, validator: validateFunc && validateFunc.bind(this) };
    }

    handleItemChange(val, field) {
        // 对向谁发起作特殊处理
        if (field.prop === 'assigned') {
            Object.keys(val).forEach(key => {
                this.formData[key] = val[key];
            });
        } else {
            this.formData[field.prop] = val;
        }
        // 对setting作特殊处理
        if (field.prop === 'setting') {
            this.formData.hidden = val.includes('isHidden');
            this.formData.required = val.includes('isRequired');
        }
        this.$emit('change', this.formData);
    }

    // hack方式：如果向谁发起设置了服务目录和处理人都隐藏，需要隐藏向谁发起（但是暂时还要依赖里面的逻辑）
    isHiddenAssign(field) {
        return (
            this.name !== 'visibleFields' && field.identify === 'assigned' && field.extraSettings.isItemHidden && field.extraSettings.isAssignedHidden
        );
    }

    get formatFieldSchema() {
        const schema = [];
        this.schema.forEach(val => {
            if (val.identify !== 'city') {
                schema.push(val);
            }
        });

        const res = schema.map((field, index) => {
            const defaultAttributes = field.defaultAttributes || {};
            const fieldRes: CommonTypes.customField = {
                name: field.name,
                instruction: field.instruction || '',
                // 1为系统字段，2为自定义字段，3为三方集成字段
                type: field.type,
                identify: field.identify || '',
                // 创建模式下没有id，前端自行定义了组件类型+数字的prop
                prop: field.identify || `${FieldToCompontent[field.inputType]}${index}`,
                component:
                    field.type === 3
                        ? 'componentThirdField'
                        : field.inputType
                        ? FieldToCompontent[field.inputType]
                        : SysFieldToComponent[field.identify] || `component${firstUpperCase(field.identify)}`,
                defaultValue: this.initDefaultValue(field),
                options: field.options,
                required: field.isRequired === undefined ? defaultAttributes.isRequired : field.isRequired,
                hidden: field.isHidden === undefined ? defaultAttributes.isHidden : field.isHidden,
                editable: field.editable === undefined ? true : field.editable,
                extraSettings: field.extraSettings === undefined ? defaultAttributes && defaultAttributes.extraSettings : field.extraSettings
            };

            if (field.id) {
                fieldRes.id = field.id;
            }

            return fieldRes;
        });

        return res;
    }

    // 初始化默认值
    initDefaultValue(field) {
        let defaultVal: any = '';
        if (field.defaultValue) {
            defaultVal = field.defaultValue;
        } else if (field.options && field.options.length > 0) {
            const defaultOptions = [];
            field.options.forEach(option => {
                if (option.isDefault) {
                    defaultOptions.push(option.value);
                }
            });
            // 如果是多选 默认值是数组
            if (field.inputType && field.inputType.indexOf('MULTI') > -1) {
                defaultVal = defaultOptions;
            } else {
                defaultVal = defaultOptions[0] || '';
            }
        }
        return defaultVal;
    }

    editFormItem(field, index: number) {
        this.clearEditStatus();
        this.activeKey = field.prop;
        this.$emit('edit', field, index);
    }

    // 修复删除字段后的状态
    deleteItem(index: number) {
        this.activeKey = '';
        this.schema.splice(index, 1);
        this.schemaChange();
        this.clearEditStatus();
    }

    // 清除选中状态
    clearEditStatus() {
        this.activeKey = '';
    }

    // 重置为当前第一个选项
    setFirstStatus() {
        this.$nextTick(() => {
            this.editFormItem(this.formatFieldSchema[0], 0);
        });
    }

    canDelete(field) {
        // 当字段属于自定义字段或者以上系统字段时，可以删除
        // return (field.type === 2 || canDeleteArr.includes(field.prop));
        return field.type === 2 || field.type === 3;
    }

    // 确保拖拽后状态正确更新
    onDropEvent(dropResult) {
        const { removedIndex, addedIndex, payload } = dropResult;
        // 每次拖拽重新填装数据 忽略这种情况触发的事件
        if (removedIndex === null && addedIndex === null) {
            return;
        }
        // removeIndex 区分是否从外部拖拽
        if (removedIndex !== null && addedIndex !== null) {
            // 如果拖拽的是当前active的字段 需要更新字段位置
            if (payload && payload.prop === this.activeKey) {
                this.$emit('edit', payload, addedIndex);
            }
            this.schema = applyDrag(this.schema, dropResult);
            this.schemaChange();
        }
    }

    schemaChange() {
        const transformedSchema = replaceContinuousThirdFields(this.schema);
        this.$emit('schema-change', transformedSchema);

        /**
         * 将ownerId相同的连续三方字段替换成`addThirdField`模版预览里的字段类型.
         */
        function replaceContinuousThirdFields(fields: CommonTypes.customField[]) {
            const res: CommonTypes.customField[] = [];

            let ptr = 0;
            while (ptr < fields.length) {
                const leader = fields[ptr];
                if (!ThirdFieldUtils.isThirdField(leader)) {
                    res.push(leader);
                    ptr++;
                    continue;
                }

                const id = leader.ownerId;
                ptr++;
                while (ptr < fields.length) {
                    const nextItem = fields[ptr];
                    if (!ThirdFieldUtils.isThirdField(nextItem) || nextItem.ownerId !== id) {
                        break;
                    }
                    ptr++;
                }
                res.push({
                    id,
                    name: '',
                    instruction: '',
                    type: 3,
                    component: 'componentThirdField',
                    inputType: 'THIRD_FIELD',
                    defaultValue: '',
                    isRequired: false,
                    isHidden: false
                });
            }

            return res;
        }
    }

    hiddenChange(isHidden) {
        this.$emit('hidden-change', isHidden);
    }
}
